import { gql } from '@apollo/client';

export const FILTERED_INSTITUTION_PROVINCES = gql`
  query FilteredInstitutionProvinces($input: FilterArgs!) {
    provinces: filteredInstitutionProvinces(input: $input) {
      id
      name
    }
  }
`;
